import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

await i18n
    // fetch using http
    .use(Backend)
    // detect language
    .use(LanguageDetector)
    // connect with React
    .use(initReactI18next)
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: false,

        detection: {
            order: ['path'],
        },

        fallbackLng: 'en',

        returnEmptyString: false, // use the key as the default value

        interpolation: {
            escapeValue: false, // react already safe from xss
        },

        backend: {
            loadPath: '/locale/{{lng}}/{{ns}}.json', // path where the XHR backend will fetch the files from
        },
    });

export default i18n;
